import React from "react";
import PropTypes from "prop-types";
import { awsUrl} from "../../helpers";

import { gsap } from "../../gsap";
import { SplitText } from "../../gsap/SplitText";
import { useGSAP } from "../../gsap/react";

gsap.registerPlugin(SplitText, useGSAP);

const UnlockedPortalIntroFoodBeverage = ({ className }) => {
  return (
    <div className={`w-full relative overflow-hidden mt-[55px]`}>
      <div className="flex-grow bg-white w-full text-center lg:border-b-[15px] border-[#052049]">
        <div className="bg-white py-8 px-[24px] lg:p-8 w-full flex flex-col justify-center h-full">
          <div className="flex flex-col items-center justify-center max-w-[801px] mx-auto">
            <div>
              <img
                className={`mx-auto mb-3 w-[80px] lg:w-[87px] drop-shadow-white lg:mr-6`}
                id="featured-icon"
                src={`${awsUrl}/media/food-beverage/icon.svg`}
                alt={`Food Beverage icon`}
                aria-hidden={true}
              />
            </div>
            <div>
              <h1
                id="featured-hero-headline"
                className="text-[38px] lg:text-[40px] text-[#052049] leading-[46px] mb-[13px] lg:mb-4 text-millik drop-shadow-white text-center"
              >
                <span className="block text-millik text-[45px] lg:text-[60px] text-center tracking-tight -ml-2 lg:ml-0 leading-none">
                  Welcome to the ultimate flavor paradise
                </span>
              </h1>
            </div>
          </div>
          <p
            id="featured-hero-body"
            className="mb-4 text-[19px] leading-[25px] max-w-[901px] mx-auto text-center text-[#052049]"
          >
            <span className={`block mb-[20px]`}>
              With more than 30 venues, you’re never far from a delicious meal or a refreshing
              cocktail at Celebration Key<sup>™</sup>. Enjoy authentic Bahamian specialties, fresh
              seafood, beachside bites, tropical drinks, and so much more. There’s something for
              every&nbsp;tastebud.
            </span>


              {/*<div className={`bg-[#0C1F46] text-white font-instrument text-[18px] md:text-[20px] font-bold h-12 leading-none px-10 lg:px-20 py-2 flex items-center justify-center md:max-w-[600px] mx-auto `}><a*/}
              {/*   target="_blank" rel="noreferrer"*/}
              {/*  className={``}*/}
              {/*  href={`https://www.carnival.com/-/media/images/celebration-key/food-and-drinks/celebration-key-dining-guide.pdf`}*/}

              {/*  onClick={() => {*/}
              {/*    triggerGAEvent(`food-beverage_guide`);*/}
              {/*  }}*/}
              {/*  aria-label="Check Out The Dining Guide"*/}
              {/*>Check Out The Dining&nbsp;Guide*/}
              {/*</a>*/}
              {/*</div>*/}



          </p>
        </div>
      </div>
    </div>
  );
};

UnlockedPortalIntroFoodBeverage.propTypes = {
  isPlaying: PropTypes.bool.isRequired
};

export default UnlockedPortalIntroFoodBeverage;
